import { apiClient } from './client';

const IS_DEMO = import.meta.env.VITE_DEMO_MODE === 'true';

export interface QueryRequest {
  sourceId: number;
  parameters?: Record<string, string>;
  timeout?: number;
}

export interface QueryResponse<T = Record<string, unknown>> {
  success: boolean;
  data: T[];
  rowCount: number;
  executionTimeMs: number;
  errorMessage?: string | null;
}

/**
 * Panel'in tüm rapor sorguları bu helper'ı kullanır.
 * Demo build (VITE_DEMO_MODE=true) → /api/v2/demo/query (tenant şemasından sentetik veri okur).
 * Normal build → /api/v1/query (agent'a proxy'lenir).
 */
export async function queryDataSource<T = Record<string, unknown>>(
  req: QueryRequest,
): Promise<QueryResponse<T>> {
  const url = IS_DEMO ? '/api/v2/demo/query' : '/api/v1/query';
  const { data } = await apiClient.post<QueryResponse<T>>(url, {
    sourceId: req.sourceId,
    parameters: req.parameters ?? {},
    timeout: req.timeout ?? 30,
  });
  return data;
}
